import { layout } from '@features/lci-report/domain/dimensions';
import { theme } from '@features/lci-report/domain/theme';
import { contentSlideHeader } from '@features/lci-report/utils';
import { Slide, TextProps, getColumnXPositions } from '@features/powerpoint';
import { partition } from '@utils/arrays';
import { TITLE } from '../../shared/dark-background-slide-master';
import { getDefinitions } from './domain/content';
import { calculateRunningTotal } from './domain/pages';
import { Glossary } from '@features/glossary';

const COLUMNS_PER_PAGE = 3;
const FONT_SIZE = 7;

const COLUMNS = getColumnXPositions(
  0.74,
  layout.width - 2 * 0.74,
  COLUMNS_PER_PAGE,
  0.25
);

type GlossarySlidesProps = {
  entriesPerColumn: readonly number[];
  glossary: Glossary;
};

export const glossarySlides = (props: GlossarySlidesProps): Slide[] => {
  const glossaryEntries = Object.values(props.glossary).toSorted((a, b) =>
    a.label.localeCompare(b.label)
  );
  const pages = partition(props.entriesPerColumn, COLUMNS_PER_PAGE);
  const runningTotal = calculateRunningTotal(props.entriesPerColumn);
  const totalEntries = props.entriesPerColumn.reduce(
    (acc, cur) => acc + cur,
    0
  );

  if (totalEntries !== glossaryEntries.length)
    console.error(
      `Glossary entry count does not match totals per column: Got ${totalEntries}, expected ${glossaryEntries.length}`
    );

  return pages.map((columnEntries, pageIndex) => ({
    slideMaster: TITLE,
    texts: [
      contentSlideHeader('Glossary', { color: theme.colors.white }),
      ...columnEntries.map(
        (_, columnIndex): TextProps => ({
          ...getDefinitions(
            glossaryEntries,
            pageIndex * COLUMNS_PER_PAGE + columnIndex,
            runningTotal
          ),
          options: {
            fontSize: FONT_SIZE,
            x: COLUMNS.positions[columnIndex],
            y: 1.64,
            w: COLUMNS.columnWidth,
            h: layout.height - 2,
            color: theme.colors.white,
            valign: 'top',
          },
        })
      ),
    ],
  }));
};
